/**
 * Add the standard ICD-10-CM decimal after its three-character category for display.
 * Leave category-only and already-dotted values unchanged so presentation formatting
 * never masks malformed input or changes the operational value being reviewed.
 */
export function formatIcd10CodeForDisplay(code: string): string {
  if (code.length <= 3 || code.includes('.')) {
    return code;
  }
  return `${code.slice(0, 3)}.${code.slice(3)}`;
}
